import MyMediaPlayer from 'js/collections/media/player';

require('vendor/assets/components/fitvids/jquery.fitvids')
require('./webpage_preview')
require('boclips/components/lp_boclips_videos_manager')

LpBoclipsVideosManager = LP.module('LpBoclips').LpBoclipsVideosManager

window.onYouTubeIframeAPIReady = () =>
  youtubeContainer = $('.youtube-container')
  if youtubeContainer.length > 0
    youtubeContainerData = youtubeContainer.data()
    YoutubeVideoManager.youtubeIFrameApiInitialized(
      youtubeContainerData['youtubeId'],
      youtubeContainerData['youtubeType'],
      youtubeContainerData['youtubePlaylistId'],
      youtubeContainerData['index'],
      youtubeContainerData['firewallToken']
    )

class VideoItemsManager
  @players: {
    'youtube': {}
  }

  @stopVideoIfPlaying: ($slide) ->
    slideData = $slide.data()
    return unless slideData && slideData['type'] == 'video'
    YoutubeVideoManager.stopVideoIfPlaying($slide)
    VimeoVideoManager.stopVideoIfPlaying($slide)
    TedVideoManager.stopVideoIfPlaying($slide)
    LpBoclipsVideosManager.stopVideoIfPlaying($slide)
    LoomVideoManager.stopVideoIfPlaying($slide)
    TeachertubeVideoManager.stopVideoIfPlaying($slide)
    EdpuzzleVideoManager.stopVideoIfPlaying($slide)
    DriveVideoManager.stopVideoIfPlaying($slide)
    MyVRSpotManager.stopVideoIfPlaying($slide)
    FileVideoManager.stopVideoIfPlaying($slide)

  @showVideo: ($slideElement, url, data = {}) =>
    if data.fromMyMedia
      props = {
        url: url,
        onEmbedCallback: data.onEmbedCallback || false,
        pauseOnOutsideClick: true,
        fromPlayer: data.inPlayer || false,
        needsDuration: data.needsDuration || false,
        withAddToFolderBtn: data.withAddToFolderBtn || false,
        id: data.id
      }
      MyMediaPlayer.render($slideElement[0], props)
    else if url.toLowerCase().indexOf('youtu') >= 0
      $('#player-loader').show()
      YoutubeVideoManager.showYoutubeVideo($slideElement, url, data)
    else if @.isBoclips(url)
      LpBoclipsVideosManager.showBoclipsVideo($slideElement, url, data)
    else if url.toLowerCase().indexOf('vimeo') >= 0
      VimeoVideoManager.showVimeoVideo($slideElement, url)
    else if url.toLowerCase().indexOf('ted') >= 0
      TedVideoManager.showTedVideo($slideElement, url)
    else if url.toLowerCase().indexOf('loom') >= 0
      LoomVideoManager.showLoomVideo($slideElement, url)
    else if url.toLowerCase().indexOf('teachertube') >= 0
      TeachertubeVideoManager.showTeachertubeVideo($slideElement, url)
    else if url.toLowerCase().indexOf('edpuzzle') >= 0
      EdpuzzleVideoManager.showEdpuzzleVideo($slideElement, url)
    else if url.toLowerCase().indexOf('drive.google') >= 0
      DriveVideoManager.showDriveVideo($slideElement, url)
    else if url.toLowerCase().indexOf('live.myvrspot') >= 0
      MyVRSpotManager.showMyVRSpotVideo($slideElement, url)
    else
      FileVideoManager.showFileVideo($slideElement, url)

  @updateButton: ($slideElement, url, data) ->
    if @isBoclips(url)
      LpBoclipsVideosManager.updateButton($slideElement, url, data)

  @isBoclips: (url) ->
    LpBoclipsVideosManager.isBoclips(url)

  @isFileVideo: (data) ->
    data.type == 'video' && data.extractedType in ['mov', 'mp4']

  @resizeSlide: ($slide) ->
    $slide ||= $('.rrp-content[aria-hidden=false]')
    $slide.closest('.bx-viewport').height($slide.height())

  @appendVideoClippingTool: ($element, url, data) ->
    $toolAnchor = $element.find('#video-clipping-tool')
    return if !data.videoClipper? || $toolAnchor.length != 1

    ReactDOM.createRoot($toolAnchor[0]).render(
      React.createElement(LP.module('SharedCollections').VideoClippingTool, {
        slideElement: $element,
        url: url,
        data: data
      })
    );

  # needed by the clipping tool
  @reloadVideo: ($slideElement, url, data = {}) =>
    if data.fromMyMedia
      props = {
        clipReload: true,
        playFrom: data.clipStart,
        playTo: data.clipEnd
      }
      MyMediaPlayer.render($slideElement[0], props)
    else if url.toLowerCase().indexOf('youtu') >= 0
      $('#player-loader').show()
      videoType = 'video'
      video_id = YoutubeVideoManager.getYoutubeId(url)
      playlistId = YoutubeVideoManager.getPlaylistYoutubeId(url)
      if !video_id? || ['null', 'undefined'].includes(String(video_id))
        video_id = playlistId
        playlistId = null
        videoType = 'playlist'
      firewallToken = LP.WebpagePreview.getFirewallToken(url)
      YoutubeVideoManager.reloadPlayer(video_id, videoType, playlistId, data, firewallToken)
    else if @.isBoclips(url)
      LpBoclipsVideosManager.reloadVideo($slideElement, url, data)

  # needed by the clipping tool
  @getVideoIdOrUrl: ($slideElement, url, data = {}) =>
    if url.toLowerCase().indexOf('youtu') >= 0
      video_id = YoutubeVideoManager.getYoutubeId(url)
      if !video_id? || ['null', 'undefined'].includes(String(video_id))
        YoutubeVideoManager.getPlaylistYoutubeId(url)
      else
        video_id
    else if @.isBoclips(url)
      LpBoclipsVideosManager.getVideoId($slideElement, url, data)
    else if url.toLowerCase().indexOf('vimeo') >= 0
      VimeoVideoManager.getVimeoId(url)
    else if url.toLowerCase().indexOf('ted') >= 0
      TedVideoManager.getTedEmbedUrl(url)
    else
      data.originalUrl || url

  @getClipDataAttributes: (data = {}, { as_string } = { as_string: true }) ->
    clipAttrs = ['clipStart', 'clipEnd', 'clipDuration'].reduce((memo, key) ->
      keyName = "#{key}".split(/(?=[A-Z])/).join('-').toLowerCase()
      memo[keyName] = parseInt(data[key], 10) if data[key]?
      memo[keyName] = '' if memo[keyName]? && (Number.isNaN(memo[keyName]) || memo[keyName] == null || typeof(memo[keyName]) == 'undefined')
      memo
    , {})
    str = ("data-#{key}='#{value}'" for own key, value of clipAttrs).join(' ')
    if as_string then str else clipAttrs

class VimeoVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $vimeoContainer = $slide.find('.vimeo-container')
    if $vimeoContainer.length
      `import(/* webpackChunkName: 'vimeo-player' */ '@vimeo/player')`.then((module) ->
        id = $vimeoContainer.data()['vimeoId']
        player = new module.default($("#vimeo-player-#{id}")[0])
        player.pause()
      )
  @showVimeoVideo: ($slideElement, url) =>
    vimeoId = @getVimeoId(url)
    embedUrl = LP.WebpagePreview.appendFirewallToken(url, "https://player.vimeo.com/video/#{vimeoId}")
    $slideElement.html("
        <iframe id=vimeo-player-#{vimeoId} data-vimeo-id=#{vimeoId} class='vimeo-container pt50 pb25' width='640' height='500' src='#{embedUrl}' frameborder='0' allowfullscreen></iframe>
    ")
    $slideElement.fitVids()
    VideoItemsManager.resizeSlide($slideElement)

  @getVimeoId: (url) ->
    regExp = /(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/
    match = url.match(regExp)
    if match && match[5].length
      match[5]

class YoutubeVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $youtubeContainer = $slide.find('.youtube-container')
    if $youtubeContainer.length and YoutubeVideoManager.youtubePlayers?
      currentPlayer = YoutubeVideoManager.youtubePlayers[$youtubeContainer.data('youtubeId')]
      if currentPlayer && currentPlayer.getPlayerState() == YT.PlayerState.PLAYING
        currentPlayer.pauseVideo()

  @youtubeIFrameApiInitialized: (youtubeId, youtubeType, youtubePlaylistId, index, firewallToken) =>
    @youtubePlayers = {}
    @youtubeApiInitialized = true
    @initializeYoutubePlayer(youtubeId, youtubeType, youtubePlaylistId, index, firewallToken)

  @getPlayerVars: (videoId, videoType, playlistId, index, firewallToken) ->
    data = $("#yt-player-wrapper-#{index}-#{videoId}").data()
    playerVars = { 'rel': 0 , 'enablejsapi': 1, origin: window.location.origin }
    if data.clipStart? && String(data.clipStart) != ''
      playerVars.start = data.clipStart
    if data.clipEnd? && String(data.clipEnd) != ''
      playerVars.end = data.clipEnd
    if !playlistId? || ['null', 'undefined'].includes(String(playlistId))
      playlistId = null
    if videoType == 'playlist' || playlistId?
      playerVars.listType = 'playlist'
      playerVars.list = playlistId || videoId
    if firewallToken
      playerVars[LP.WebpagePreview.FIREWALL_TOKEN_PARAM] = firewallToken
    playerVars

  @initializeYoutubePlayer: (videoId, videoType, playlistId, index, firewallToken) ->
    iframeId = "yt-player-#{index}-#{videoId}"
    options = {
      height: '500'
      width: '640'
      playerVars: YoutubeVideoManager.getPlayerVars(videoId, videoType, playlistId, index, firewallToken)
    }
    if videoType != 'playlist'
      options.videoId = videoId
    options.events = {
      onReady: ->
        # To remove the visible iframe resize.
        $('.youtube-container').removeClass('hide')
        YoutubeVideoManager.youtubePlayers[videoId] = player
        VideoItemsManager.players['youtube']["#{videoId}"] = player
        $("#yt-player-#{index}-#{videoId}").closest('.rrp-content').fitVids();
        VideoItemsManager.resizeSlide()
        $('#player-loader').hide()
      onStateChange: (state) ->
        if state.data == YT.PlayerState.PLAYING && $('#' + iframeId).closest('.selected').length == 0
          player.pauseVideo()
    }
    player = new (YT.Player)(iframeId, options)

  @reloadPlayer: (videoId, videoType, playlistId, data, firewallToken) ->
    if YoutubeVideoManager.youtubePlayers? && YoutubeVideoManager.youtubePlayers[videoId]?
      YoutubeVideoManager.youtubePlayers[videoId].destroy()
      data.i = 0 unless data.i >= 0
      $("#yt-player-#{data.i}-#{videoId}").remove()
      $("#yt-player-wrapper-#{data.i}-#{videoId}").append(@.playerContainer(videoId,videoType, playlistId, data.i, firewallToken))
      $("#yt-player-wrapper-#{data.i}-#{videoId}").data(VideoItemsManager.getClipDataAttributes(data, as_string: false))
      window.onYouTubeIframeAPIReady()

  @playerContainer: (videoId, videoType, playlistId, index, firewallToken) ->
    "<div id=yt-player-#{index}-#{videoId}  data-youtube-playlist-id='#{playlistId}' data-youtube-type='#{videoType}' data-youtube-id=#{videoId} data-index='#{index}' data-firewall-token='#{firewallToken}' class='youtube-container hide pt50 pb25' width='640' height='500'></div>"

  @showYoutubeVideo: ($slideElement, url, data = {}) =>
    data.i = 0 unless data.i >= 0
    videoType = 'video'
    videoId = @getYoutubeId(url)
    playlistId = @getPlaylistYoutubeId(url)
    firewallToken = LP.WebpagePreview.getFirewallToken(url)
    if !videoId? || ['null', 'undefined'].includes(String(videoId))
      videoId = playlistId
      playlistId = null
      videoType = 'playlist'
    $slideElement.html("
      <div id='yt-video-container-#{data.i}-#{videoId}' class='yt-video-container' data-youtube-playlist-id='#{playlistId}' data-youtube-type='#{videoType}' data-index='#{data.i}' data-youtube-id='#{videoId}'>
        <div id='yt-player-wrapper-#{data.i}-#{videoId}' class='fluid-width-video-wrapper yt-player-wrapper' data-index='#{data.i}'   data-youtube-playlist-id='#{playlistId}' data-youtube-type='#{videoType}' data-youtube-id='#{videoId}' #{VideoItemsManager.getClipDataAttributes(data)}>
          #{@.playerContainer(videoId, videoType, playlistId, data.i, firewallToken)}
        </div>
        <div id='video-clipping-tool'></div>
      </div>
   ")
    if @youtubeApiInitialized
      @initializeYoutubePlayer(videoId, videoType, playlistId, data.i, firewallToken)
    else
      tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore tag, firstScriptTag

  @getYoutubeId: (url) ->
    regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    match = url.match(regExp)
    if match and match[2].length == 11
      match[2]

  @getPlaylistYoutubeId: (url) ->
    playlistRegex = /(play)?(list=)([^\?&#%]*)(?=&|%26|#|%23|$)/
    match = url.match(playlistRegex)
    if match and match.length == 4
      match[3]

class TedVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $tedContainer = $slide.find('.ted-container')
    if $tedContainer.length
      $tedContainer.attr('src', $tedContainer.attr('src'))

  @showTedVideo: ($slideElement, url) =>
    embedUrl = LP.WebpagePreview.appendFirewallToken(url, TedVideoManager.getTedEmbedUrl(url))
    $slideElement.html("
      <iframe class='ted-container pt50 pb25' width='578' height='400' src='#{embedUrl}' frameborder='0' allowfullscreen></iframe>
    ")
    $slideElement.fitVids({ customSelector: "iframe[src^='https://embed.ted.com']" })
    VideoItemsManager.resizeSlide($slideElement)

  @getTedEmbedUrl: (url) ->
    return url if url.indexOf('://embed.ted.com/') > -1
    [category,tedVideoId] = @getTedVideoCategoryAndId(url)
    return url if String(category) == '' || String(tedVideoId) == ''
    embedUrl = "https://embed.ted.com"
    language = @.getQueryVariable(url, 'language')
    if String(category).startsWith('talks') && String(language) != ''
      "#{embedUrl}/talks/lang/#{language}/#{tedVideoId}"
    else
      "#{embedUrl}/#{category}/#{tedVideoId}"

  @getTedVideoCategoryAndId: (url) ->
    regExp = /(https?:\/\/)?(www|embed)?\.?ted.com\/([a-z\/\d]*)\/([^?\/#]+)/
    match = url.match(regExp)
    return unless match
    [match[3], match[4]]

  @getQueryParameters: (url) ->
    parser = document.createElement("a")
    parser.href = LP.WebpagePreview.decodeStr($.trim(String(url)))
    LP.WebpagePreview.decodeURIParams(parser.search)

  @getQueryVariable: (url, variable) ->
    vars = @getQueryParameters(url)
    result = ''
    for key, value of vars
      if LP.WebpagePreview.decodeStr(key) == variable
        result = LP.WebpagePreview.decodeStr(value)
        break
    result

class LoomVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $loomContainer = $slide.find('.loom-container')
    if $loomContainer.length
      $loomContainer.attr('src', $loomContainer.attr('src'))

  @showLoomVideo: ($slideElement, url) =>
    loomId = LoomVideoManager.getLoomId(url)
    $slideElement.html("
      <iframe class='loom-container pt50 pb25' width='630' height='394' src='https://www.useloom.com/embed/#{loomId}' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    ")
    $slideElement.fitVids({ customSelector: ".loom-container" })
    VideoItemsManager.resizeSlide($slideElement)

  @getLoomId: (url) ->
    match = url.match(/\/([^\/]+)\/?$/)[1]

class TeachertubeVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $teachertubeContainer = $slide.find('.teachertube-container')
    if $teachertubeContainer.length
      $teachertubeContainer.attr('src', $teachertubeContainer.attr('src'))

  @showTeachertubeVideo: ($slideElement, url) =>
    teachertubeId = TeachertubeVideoManager.getTeachertubeId(url)
    embedUrl = LP.WebpagePreview.appendFirewallToken(url, "https://www.teachertube.com/embed/videos/#{teachertubeId}")
    $slideElement.html("
      <iframe class='teachertube-container pt50 pb25' width='600' height='400' frameborder='0' allowfullscreen='' src='#{embedUrl}' ></iframe>
    ")
    $slideElement.fitVids({ customSelector: ".teachertube-container" })
    VideoItemsManager.resizeSlide($slideElement)

  @getTeachertubeId: (url) ->
    match = url.match(/\d+(?:\.\d+)?/g)[0]

class EdpuzzleVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $edpuzzleContainer = $slide.find('.edpuzzle-container')
    if $edpuzzleContainer.length
      $edpuzzleContainer.attr('src', $edpuzzleContainer.attr('src'))

  @showEdpuzzleVideo: ($slideElement, url) =>
    edpuzzleId = EdpuzzleVideoManager.getEdpuzzleId(url)
    $slideElement.html("
      <iframe class='edpuzzle-container pt50 pb25' width='470' height='402' src='https://edpuzzle.com/embed/media/#{edpuzzleId}' frameborder='0' allowfullscreen></iframe>
    ")
    $slideElement.fitVids({ customSelector: ".edpuzzle-container" })
    VideoItemsManager.resizeSlide($slideElement)

  @getEdpuzzleId: (url) ->
    match = url.match(/\/([^\/]+)\/?$/)[1]

class DriveVideoManager

  @stopVideoIfPlaying: ($slide) ->
    $driveContainer = $slide.find('.drive-container')
    if $driveContainer.length
      $driveContainer.attr('src', $driveContainer.attr('src'))

  @showDriveVideo: ($slideElement, url) =>
    driveUrl = DriveVideoManager.getDriveUrl(url)
    $slideElement.html("<iframe class='drive-container pt50 pb25' src='#{driveUrl}' width='640' height='480' allow='autoplay' allowfullscreen></iframe>
    ")
    $slideElement.fitVids({ customSelector: ".drive-container" })
    VideoItemsManager.resizeSlide($slideElement)

  @getDriveUrl: (url) ->
    url = url.replace('/view', '/preview')

class MyVRSpotManager

  @stopVideoIfPlaying: ($slide) ->
    $myVRSpotContainer = $slide.find('.myvrspot-container')
    if $myVRSpotContainer.length
      $myVRSpotContainer.attr('src', $myVRSpotContainer.attr('src'))

  @showMyVRSpotVideo: ($slideElement, url) =>
    $slideElement.html("
      <iframe class='myvrspot-container pt50 pb25 iframe-content' src='#{url}' style='max-height: auto !important;max-width: 720px !important;' frameborder='0' scrolling='no' allowfullscreen mozallowfullscreen webkitallowfullscreen></iframe>
    ")
    $slideElement.fitVids({ customSelector: ".myvrspot-container" })
    VideoItemsManager.resizeSlide($slideElement)


class FileVideoManager

  @stopVideoIfPlaying: ($slide) ->
    data = $slide.data()
    data.i = 0 unless data.i >= 0
    $videoContainer = $slide.find("#file-video-item-#{data.i}")
    if $videoContainer.length > 0
      el = $videoContainer[0]
      el.pause()

  @bindOnError: ($slideElement, data) ->
    $videoContainer = $slideElement.find("#file-video-item-#{data.i}")
    $($videoContainer).on 'error', ->
      SharedPlayer.PlayerItemRenderer._showNonInteractive($slideElement, data)

  @showFileVideo: ($slideElement, url) ->
    data = $slideElement.data()
    data.i = 0 unless data.i >= 0
    $slideElement.html("
      <div class='file-video-container' id='file-video-container-#{data.i}'>
       <div id='file-video-wrapper'>
         <video id='file-video-item-#{data.i}' class='file-video-item' controls>
           <source src='#{url}' type='video/mp4'>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    ")
    FileVideoManager.bindOnError($slideElement, data)
    $slideElement.fitVids({ customSelector: ".file-video-container" })
    VideoItemsManager.resizeSlide($slideElement)

LP.module('SharedPlayer').VideoItemsManager = VideoItemsManager
LP.module('SharedCollections').VideoItemsManager = VideoItemsManager
